export default __webpack_public_path__ + "static/media/WeAceLoader.d8d68566.gif";